/**
 * This exists only to be a value for NodeModelType
 */
export enum ITNodeType {
    IT = "it"
}
